import {filter, map} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';

type ContractADLMsg = ws.ContractADLMsg;

export const adlData$ = wsMsg$.pipe(
  filter((o: ContractADLMsg) => !!o.position_info),
  map((o: ContractADLMsg) => o.position_info)
);
